const navigateToCheckout = (navigate, items, source = "direct") => {
  // items should be an array of: { productId, variantId, sizeId, quantity, price, mrp, image, productName }
  
  const subtotal = items.reduce((acc, item) => acc + (item.mrp * item.quantity), 0);
  const payable = items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
  const discount = subtotal - payable;

  navigate("/check-out-page", {
    state: {
      items,
      summary: {
        subtotal,
        discount,
        payable,
      },
      source // 'cart' or 'direct'
    },
  });
};

export default navigateToCheckout;

// import { useNavigate } from "react-router-dom";
// import { navigateToCheckout } from "../helpers/checkoutHelper";

// const handleBuyNow = () => {
//   const productToBuy = [{
//     productId: product._id,
//     variantId: selectedVariant?._id,
//     sizeId: selectedSize?._id,
//     quantity: 1,
//     price: product.sellingPrice,
//     mrp: product.price,
//     image: product.productImage[0],
//     productName: product.productName,
//     size: selectedSize?.name,
//     color: selectedVariant?.colorName
//   }];

//   navigateToCheckout(navigate, productToBuy, "direct");
// };